export enum IBAN {
  BUILDINGS_MANAGEMENT = 'HR9024000081110178472',
  HEATING = 'HR4724000081510400470'
}
